import React from 'react'
import { RadioButton } from '@progress/kendo-react-inputs';


export function UiRadioButton(props) {

    const {
        validationMessage,
        label,
        visited,
        handleChange,
        placeholder,
        value,
        checked,
        name,
        ...others
      } = props;
    

    return (
        <>
            <RadioButton name={name} onChange={handleChange} value={value} label={label} />
            {visited && validationMessage && <Error>{validationMessage}</Error>}
            
        </>
    )
}
